import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { customFontsQueryOptions } from '@/query/customFontsQueryOptions';

interface UseAnnouncementFontsResult {
  fontIdByName: Map<string, number>;
  fontNameById: Map<number, string>;
}

// The rich text editor round-trips fonts by name (tiptap mark attrs) while
// the backend DTO round-trips them by id — these two lookup directions are
// how load/save translate between the two.
export const useAnnouncementFonts = (): UseAnnouncementFontsResult => {
  const { data: fonts } = useSuspenseQuery(customFontsQueryOptions);

  const fontIdByName = useMemo(
    () => new Map(fonts.map((font) => [font.name, font.id])),
    [fonts],
  );

  const fontNameById = useMemo(
    () => new Map(fonts.map((font) => [font.id, font.name])),
    [fonts],
  );

  return { fontIdByName, fontNameById };
};
